module.exports = __webpack_public_path__ + "9771f2aa4d529ef191aba6b197f91bc1.svg";